/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const test = {
    "aws_project_region": "us-west-2",
    // "aws_cognito_identity_pool_id": "us-west-2:e9b9d3ed-37cf-4192-ad72-3ef435fd5873",
    "aws_cognito_identity_pool_id": "us-west-2:21e48823-f837-411b-a834-498ee9778fa2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_L47dsP66b",
    "aws_user_pools_web_client_id": "2sdltv59il1kjmk6nae2rg9nl0",
    "oauth": {
        "domain": "auth.uniqin.ai",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app-test.uniqin.ai/home/",
        "redirectSignOut": "https://app-test.uniqin.ai/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_mobile_analytics_app_id": "96ab1a012b9d41e9af04bc752b7fb81b",
    "aws_mobile_analytics_app_region": "us-west-2"
};

const development = {
    "aws_project_region": "us-west-2",
    // "aws_cognito_identity_pool_id": "us-west-2:e9b9d3ed-37cf-4192-ad72-3ef435fd5873",
    "aws_cognito_identity_pool_id": "us-west-2:21e48823-f837-411b-a834-498ee9778fa2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_L47dsP66b",
    "aws_user_pools_web_client_id": "hfi5l9oopchoko1sdjl99aqmu",
    "oauth": {
        "domain": "uiv2-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:8080/home/",
        "redirectSignOut": "http://localhost:8080/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_mobile_analytics_app_id": "96ab1a012b9d41e9af04bc752b7fb81b",
    "aws_mobile_analytics_app_region": "us-west-2"
};

const production = {
    "aws_project_region": "us-west-2",
    // "aws_cognito_identity_pool_id": "us-west-2:e9b9d3ed-37cf-4192-ad72-3ef435fd5873", 
    "aws_cognito_identity_pool_id": "us-west-2:21e48823-f837-411b-a834-498ee9778fa2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_L47dsP66b",
    "aws_user_pools_web_client_id": "6e6c4ns6ltqch1vhp1g5lfdn34",
    "oauth": {
        "domain": "auth.uniqin.ai",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.uniqin.ai/home/",
        "redirectSignOut": "https://app.uniqin.ai/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_mobile_analytics_app_id": "96ab1a012b9d41e9af04bc752b7fb81b",
    "aws_mobile_analytics_app_region": "us-west-2"
};

var awsmobile = {}

if(process.env.VUE_APP_ENV == "development") awsmobile = development
if(process.env.VUE_APP_ENV == "test") awsmobile = test
if(process.env.VUE_APP_ENV == "production") awsmobile = production

export default awsmobile;
